"use strict";
/**
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenExchangeRequest = exports.TokenStatus = exports.AadResourceUrls = exports.InnerHttpError = exports.ErrorModel = exports.ErrorResponse = exports.TokenResponse = void 0;
var mappers_1 = require("../models/mappers");
Object.defineProperty(exports, "TokenResponse", { enumerable: true, get: function () { return mappers_1.TokenResponse; } });
Object.defineProperty(exports, "ErrorResponse", { enumerable: true, get: function () { return mappers_1.ErrorResponse; } });
Object.defineProperty(exports, "ErrorModel", { enumerable: true, get: function () { return mappers_1.ErrorModel; } });
Object.defineProperty(exports, "InnerHttpError", { enumerable: true, get: function () { return mappers_1.InnerHttpError; } });
Object.defineProperty(exports, "AadResourceUrls", { enumerable: true, get: function () { return mappers_1.AadResourceUrls; } });
Object.defineProperty(exports, "TokenStatus", { enumerable: true, get: function () { return mappers_1.TokenStatus; } });
Object.defineProperty(exports, "TokenExchangeRequest", { enumerable: true, get: function () { return mappers_1.TokenExchangeRequest; } });
//# sourceMappingURL=userTokenMappers.js.map